import React from 'react';
import { getMeals, getMiles, UTILITY_IMAGES } from '../utils/storage';
import './StatsPage.css';

export function StatsPage() {
  const meals = getMeals();
  const miles = getMiles();

  // Compute actual stamp stats
  const totalMeals = meals.length;
  const socialMeals = meals.filter((m) => m.socialTag !== 'Alone').length;
  const offCampusMeals = meals.filter((m) => !m.gps.isCampus).length;
  
  // Calculate average overall experience score
  const avgScore = totalMeals > 0 
    ? (meals.reduce((sum, m) => sum + m.overallScore, 0) / totalMeals).toFixed(1)
    : '0.0';

  const milestones = [
    {
      id: 'welcome',
      title: 'Island Arrival',
      desc: 'Registered on the Food Journey app.',
      target: 1,
      current: 1,
      reward: 500,
    },
    {
      id: 'first-meal',
      title: 'First Bite Logged',
      desc: 'Logged a meal and recorded voice thoughts.',
      target: 1,
      current: totalMeals >= 1 ? 1 : 0,
      reward: 150,
    },
    {
      id: 'social-factor',
      title: 'Social Dining Club',
      desc: 'Logged meals with friends, classmates, or colleagues.',
      target: 3,
      current: Math.min(3, socialMeals),
      reward: 300,
    },
    {
      id: 'off-campus',
      title: 'Off-Campus Gastronomy',
      desc: 'Discovered and logged meals at off-campus spots.',
      target: 2,
      current: Math.min(2, offCampusMeals),
      reward: 200,
    },
  ];

  return (
    <div className="stats-page-container">
      {/* Nook Miles Header card */}
      <div className="miles-card-header">
        <div className="miles-leaf-logo">🍃</div>
        <div className="miles-header-mid">
          <div className="miles-header-title">Journey</div>
          <div className="miles-header-subtitle">Active Milestones</div>
        </div>
        <div className="miles-header-points">
          <span className="miles-points-num">{miles}</span>
          <span className="miles-points-lbl">Points</span>
        </div>
      </div>

      {/* Stats Summary Table */}
      <div className="stats-summary-card">
        <h3>📊 Food Journey Summary</h3>
        <div className="stats-summary-grid">
          <div className="summary-stat-box">
            <span className="stat-number">{totalMeals}</span>
            <span className="stat-label">Meals Logged</span>
          </div>
          <div className="summary-stat-box">
            <span className="stat-number">{avgScore}</span>
            <span className="stat-label">Avg Experience</span>
          </div>
          <div className="summary-stat-box">
            <span className="stat-number">{socialMeals}</span>
            <span className="stat-label">Social Meals</span>
          </div>
        </div>
      </div>

      {/* Stamp Milestones Cards list */}
      <div className="milestones-list">
        {milestones.map((ms) => {
          const isCompleted = ms.current >= ms.target;
          
          return (
            <div key={ms.id} className={`milestone-item ${isCompleted ? 'completed' : ''}`}>
              <div className="milestone-left">
                {/* Stamp Circle */}
                <div className="stamp-circle">
                  {isCompleted ? (
                    <img 
                      src={UTILITY_IMAGES.leaf} 
                      alt="Stamp leaf" 
                      className="stamp-leaf-img"
                    />
                  ) : (
                    <span className="stamp-lock">🔒</span>
                  )}
                </div>
              </div>

              <div className="milestone-mid">
                <div className="milestone-title">{ms.title}</div>
                <div className="milestone-desc">{ms.desc}</div>
                <div className="milestone-progress">
                  <div className="progress-bar-container">
                    <div 
                      className="progress-bar-fill"
                      style={{ width: `${(ms.current / ms.target) * 100}%` }}
                    ></div>
                  </div>
                  <span className="progress-text">{ms.current} / {ms.target}</span>
                </div>
              </div>

              <div className="milestone-right">
                <div className="miles-reward-badge">
                  <span className="reward-plus">+</span>
                  <span className="reward-val">{ms.reward}</span>
                </div>
                <div className="reward-lbl">Reward</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
export default StatsPage;
